<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="7" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="12" nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="errorTpl">
		<textarea nz-input [formControlName]="controlName()" [placeholder]="placeholder()" [rows]="rows()"></textarea>

		<ng-template #errorTpl let-control>
			@if (control.errors?.['required']) {
				This field is required
			}
			@if (control.errors?.['minlength']) {
				Must be at least {{ control.errors?.['minlength'].requiredLength }} characters
			}
		</ng-template>
	</nz-form-control>
</nz-form-item>
